<template>
  <div class="free">
 
    <twikoo-comment :env-id="TWIKOO_ENV_ID" path="/free" />
  </div>
</template>

<script>
import TwikooComment from '../components/TwikooComment.vue'
import { TWIKOO_ENV_ID } from '../config/twikoo'

export default {
    name: 'FreePage',
  components: {
    TwikooComment
  },
  setup() {
    return {
      TWIKOO_ENV_ID
    }
  }
}
</script>

<style scoped>
.free {
  width: 80%;
  /* 改为百分比宽度 */
  max-width: 1200px;
  /* 设置最大宽度 */
  margin: 0 auto;
  margin-top: 2vh;
  padding: 2rem;
  border-radius: 8px;
}
</style>
